import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const services = [
    {
      icon: 'ri-code-s-slash-line',
      title: 'Technology & Digital Services',
      description: 'Comprehensive IT advisory, cybersecurity, cloud infrastructure, software development, and AI-driven automation solutions for modern enterprises.',
      features: ['Managed IT Advisory', 'Cybersecurity & Compliance', 'Cloud & Data Infrastructure', 'Software & App Development', 'AI & Automation'],
      link: '/services/technology',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Healthcare Operations & Systems Consulting',
      description: 'Strategic consulting for healthcare providers seeking operational excellence, accreditation readiness, and digital transformation.',
      features: ['Hospital Operations Optimization', 'Accreditation & Quality Readiness', 'Healthcare Supply Chain Redesign', 'Digital Health Transformation', 'Policy & Governance'],
      link: '/services/healthcare',
    },
    {
      icon: 'ri-truck-line',
      title: 'Logistics & Transportation Advisory',
      description: 'Expert guidance for transportation companies, fleet operators, and logistics networks requiring compliance and efficiency improvements.',
      features: ['Fleet & Dispatch Optimization', 'FMCSA & DOT Compliance', 'Cost & Route Optimization', 'Warehouse & Last-Mile Strategy', 'Transportation Technology'],
      link: '/services/logistics',
    },
    {
      icon: 'ri-gas-station-line',
      title: 'Gasoline Retail & Convenience Store Consulting',
      description: 'Specialized consulting for gas station owners, convenience store operators, and fuel retail networks seeking growth and profitability.',
      features: ['Site Feasibility & Market Analysis', 'Margin & Fuel Pricing Strategy', 'Store Layout & Merchandising', 'Vendor & Fuel Supply Contracts', 'Financing & Redevelopment'],
      link: '/services/fuel-retail',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Business, Finance & Capital Advisory',
      description: 'Strategic financial consulting for businesses requiring restructuring, capital planning, and lender-ready documentation.',
      features: ['Business Restructuring', 'Capital Planning & Debt Advisory', 'Pro-Forma Financial Modeling', 'Lender-Ready Documentation', 'Risk & Insurance Advisory'],
      link: '/services/capital-advisory',
    },
  ];

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      
      <main className="pt-[90px]">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0A0A0A] to-black py-32">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="max-w-4xl">
              <div className="inline-flex items-center px-4 py-2 border border-copper/30 rounded-full mb-8">
                <span className="text-xs uppercase tracking-wider text-copper">Our Services</span>
              </div>
              <h1 className="text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
                Comprehensive Consulting{' '}
                <span className="bg-copper-gradient bg-clip-text text-transparent">
                  Across Five Divisions
                </span>
              </h1>
              <p className="text-xl text-gray-400 leading-relaxed">
                MACGOC delivers enterprise-grade advisory services designed to transform operations, drive efficiency, and achieve sustainable growth across critical business verticals.
              </p>
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="bg-charcoal-dark py-24">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="space-y-12">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="group bg-charcoal border border-charcoal-light rounded-3xl p-12 hover:border-copper transition-all duration-300"
                >
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                    {/* Left: Icon & Title */}
                    <div className="lg:col-span-1">
                      <div className="w-20 h-20 bg-copper-gradient rounded-full flex items-center justify-center mb-6">
                        <i className={`${service.icon} text-4xl text-white`}></i>
                      </div>
                      <h2 className="text-3xl font-bold text-white mb-4 leading-tight">
                        {service.title}
                      </h2>
                      <Link
                        to={service.link}
                        className="inline-flex items-center gap-2 text-copper hover:text-copper-light font-semibold transition-colors group-hover:gap-3"
                      >
                        Learn More
                        <i className="ri-arrow-right-line"></i>
                      </Link>
                    </div>

                    {/* Middle: Description */}
                    <div className="lg:col-span-1">
                      <p className="text-base text-gray-400 leading-relaxed">
                        {service.description}
                      </p>
                    </div>

                    {/* Right: Features */}
                    <div className="lg:col-span-1">
                      <ul className="space-y-3">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <i className="ri-check-line text-copper text-xl mt-0.5"></i>
                            <span className="text-sm text-gray-300">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-black py-24">
          <div className="max-w-[1400px] mx-auto px-8 text-center">
            <h2 className="text-5xl font-bold text-white mb-6">
              Ready to Get Started?
            </h2>
            <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto">
              Schedule a consultation to discuss how MACGOC can transform your operations.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-copper hover:bg-copper-light text-white px-12 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
            >
              Request Consultation
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ServicesPage;